import { createIcon } from "@chakra-ui/icons";

export const BankIcon = createIcon({
  displayName: "BankIcon",
  viewBox: "0 0 40 40",
  path: (
    <path
      d="M10 18.333V25m20-10v6.667m-1.666-15c4.08 0 6.288.624 7.386 1.109.147.064.22.097.43.298.127.12.358.475.418.64.099.274.099.424.099.724v17.914c0 1.515 0 2.272-.227 2.661-.231.396-.454.58-.887.732-.425.15-1.283-.015-3-.345-1.2-.23-2.625-.4-4.22-.4-5 0-10 3.333-16.666 3.333-4.081 0-6.289-.624-7.387-1.109-.146-.064-.22-.096-.43-.298a2.439 2.439 0 0 1-.417-.64c-.1-.274-.1-.424-.1-.724V12.648c0-1.514 0-2.272.228-2.661.23-.396.453-.58.886-.732.425-.15 1.283.015 3 .345a22.4 22.4 0 0 0 4.22.4c5 0 10-3.333 16.666-3.333ZM24.166 20a4.167 4.167 0 1 1-8.333 0 4.167 4.167 0 0 1 8.333 0Z"
      stroke="#1D2939"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="currentColor"
    />
  ),
  defaultProps: {
    width: "40px",
    height: "40px",
    color: "#B4E2CC",
  },
});
